var t={start:"end",end:"start"};function r(r){return r.replace(/start|end/g,(function(r){return t[r]}))}export{r as default};
